import React, { Component } from "react";
import { toast } from "react-toastify";
import "./facturaPublicaDetalleModal.css";

export default class FacturaPublicaDetalleModal extends Component {
    constructor(props) {
        super(props);

        const initialState = this.buildStateFromProps(props);

        this.state = {
            ...initialState,
            originalData: JSON.parse(JSON.stringify(initialState)),
            hasChanges: false,

            pagosSortKey: "",
            pagosSortDir: "asc",
            showFacturaExternaModal: false,
            showFacturaExternaConfirm: false,
            uuidFacturaExterna: "",

        };
    }

    componentDidUpdate(prevProps) {
        const openedNow = !prevProps.show && this.props.show;
        const dataChanged = prevProps.data !== this.props.data;

        if (openedNow || dataChanged) {
            const nextState = this.buildStateFromProps(this.props);

            this.setState(
                {
                    ...nextState,
                    originalData: JSON.parse(JSON.stringify(nextState)),
                    hasChanges: false,
                    pagosSortKey: "",
                    pagosSortDir: "asc",
                    showFacturaExternaModal: false,
                    showFacturaExternaConfirm: false,
                    uuidFacturaExterna: "",
                }

            );
        }
    }

    parseNumber = (value) => {
        if (value == null || value === "") return 0;

        let clean = String(value).trim();
        clean = clean.replace(/\s/g, "");

        if (clean.includes(",") && !clean.includes(".")) {
            clean = clean.replace(",", ".");
        } else if (clean.includes(",") && clean.includes(".")) {
            clean = clean.replace(/,/g, "");
        }

        const n = Number(clean);
        return Number.isNaN(n) ? 0 : n;
    };

    roundMoney = (value) => {
        const n = Number(value || 0);
        return Math.round((n + Number.EPSILON) * 100) / 100;
    };

    formatMoney = (value) => {
        return this.roundMoney(value).toFixed(2);
    };

    buildStateFromProps = (props) => {
        const item = props.data || {};
        const afiliacionApi = item?.afiliacion || {};
        const solicitudApi = item?.solicitud || {};
        const emisorApi = item?.emisor || {};
        const pagosApi = Array.isArray(item?.pagos) ? item.pagos : [];
        const productosApi = Array.isArray(item?.productos) ? item.productos : [];

        const pagos = pagosApi.map((p, idx) => ({
            ...p,
            _rowid: `${p?.idticketpago || idx}`,
            seleccionado: true,
        }));

        const totalFacturablePagos = pagos.reduce((acc, p) => {
            return acc + this.parseNumber(p?.facturable);
        }, 0);

        const totalInicial =
            this.parseNumber(item?.totalfactura) > 0
                ? this.parseNumber(item?.totalfactura)
                : totalFacturablePagos;

        const subtotalInicial =
            this.parseNumber(productosApi?.subtotal) > 0
                ? this.parseNumber(productosApi?.subtotal)
                : this.roundMoney(totalInicial / 1.16);

        const ivaInicial =
            this.parseNumber(productosApi?.iva) > 0
                ? this.parseNumber(productosApi?.iva)
                : this.roundMoney(totalInicial - subtotalInicial);

        return {
            afiliacion: {
                idafiliacion: afiliacionApi?.idafiliacion || "",
                afiliacion: afiliacionApi?.afiliacion || "",
                idmoneda: afiliacionApi?.idmoneda || "",
                banco: afiliacionApi?.banco || "",
                compania: afiliacionApi?.compania || "",
                cuenta: afiliacionApi?.cuenta || "",
                facturable: afiliacionApi?.facturable || "",
                comentarios: afiliacionApi?.comentarios || "",
                moneda: afiliacionApi?.moneda || "",
            },

            solicitud: {
                nombre: solicitudApi?.nombre || "",
                apellido: solicitudApi?.apellido || "",
                cantidad: solicitudApi?.cantidad || "",
                moneda: solicitudApi?.moneda || "",
                fecha_factura: solicitudApi?.fecha_factura || "",
                rfc: solicitudApi?.rfc || "",
                domicilio_fiscal: solicitudApi?.domicilio_fiscal || "",
                tipo_solicitud: solicitudApi?.tipo_solicitud || "",
                regimen_fiscal: solicitudApi?.regimen_fiscal || "",
                regimen_fiscal_descripcion:
                    solicitudApi?.regimen_fiscal_descripcion || "",
                serie: solicitudApi?.serie || "",
                folio: solicitudApi?.folio || "",
                forma_pago: solicitudApi?.forma_pago || "",
                forma_pago_descripcion: solicitudApi?.forma_pago_descripcion || "",
                metodo_pago: solicitudApi?.metodo_pago || "",
                metodo_pago_descripcion:
                    solicitudApi?.metodo_pago_descripcion || "",
                tipo_comprobante: solicitudApi?.tipo_comprobante || "",
                tipo_comprobante_descripcion:
                    solicitudApi?.tipo_comprobante_descripcion || "",
                uso_cfdi: solicitudApi?.uso_cfdi || "",
                uso_cfdi_descripcion: solicitudApi?.uso_cfdi_descripcion || "",
                lugar_expedicion: solicitudApi?.lugar_expedicion || "",
                periodicidad: solicitudApi?.periodicidad || "",
                periodicidad_descripcion:
                    solicitudApi?.periodicidad_descripcion || "",
                meses: solicitudApi?.meses || "",
                meses_descripcion: solicitudApi?.meses_descripcion || "",
                anyo: solicitudApi?.anyo || "",
            },

            emisor: {
                nombre: emisorApi?.nombre || "",
                rfc: emisorApi?.rfc || "",
                regimen_fiscal: emisorApi?.regimen_fiscal || "",
            },

            pagos,

            productos: productosApi.map((p, idx) => ({
                ...p,
                _rowid: idx,
                descripcion: p.descripcion || p.producto || "",
                cantidad: p.cantidad || 1,
                iva: this.formatMoney(p.iva || 0),
                subtotal: this.formatMoney(p.subtotal || 0),
                total: this.formatMoney(p.total || 0),
            })),

            resumen: {
                monedafactura: item?.monedafactura || solicitudApi?.moneda || "",
                totalfactura: this.formatMoney(totalInicial),
                ivafactura: this.formatMoney(ivaInicial),
                tipocambiofactura: item?.tipocambiofactura || 1,
            },
        };
    };

    formatCurrency = (value) => {
        return `$ ${this.formatMoney(value)}`;
    };

    areAllPagosSelected = () => {
        const { pagos } = this.state;
        if (!pagos || pagos.length === 0) return false;
        return pagos.every((p) => !!p.seleccionado);
    };

    onToggleAllPagos = () => {
        this.setState(
            (prev) => {
                const allSelected =
                    prev.pagos.length > 0 && prev.pagos.every((p) => !!p.seleccionado);

                const pagos = prev.pagos.map((p) => ({
                    ...p,
                    seleccionado: !allSelected,
                }));

                return { pagos };
            },
            () => this.recalculateFromPagos(this.state.pagos)
        );
    };


    isSameValue = (a, b) => {
        return String(a ?? "").trim() === String(b ?? "").trim();
    };

    hasSpecialChars = (value) => {
        return /[<>[\]{}|^~`]/.test(String(value || "").trim());
    };

    computeHasChanges = (nextState) => {
        const original = nextState.originalData || this.state.originalData || {};

        const payloadActual = {
            solicitud: nextState.solicitud,
            productos: (nextState.productos || []).map((p) => ({
                clave_sat: p.clave_sat || "",
                descripcion: p.descripcion || p.producto || "",
                cantidad: p.cantidad || 1,
                iva: p.iva || "",
                subtotal: p.subtotal || "",
                total: p.total || "",
            })),
            pagos: (nextState.pagos || []).map((p) => ({
                idticketpago: p.idticketpago,
                seleccionado: !!p.seleccionado,
            })),
            resumen: nextState.resumen,
        };

        const payloadOriginal = {
            solicitud: original.solicitud || {},
            productos: (original.productos || []).map((p) => ({
                clave_sat: p.clave_sat || "",
                descripcion: p.descripcion || p.producto || "",
                cantidad: p.cantidad || 1,
                iva: p.iva || "",
                subtotal: p.subtotal || "",
                total: p.total || "",
            })),
            pagos: (original.pagos || []).map((p) => ({
                idticketpago: p.idticketpago,
                seleccionado: !!p.seleccionado,
            })),
            resumen: original.resumen || {},
        };

        return JSON.stringify(payloadActual) !== JSON.stringify(payloadOriginal);
    };

    recalculateFromPagos = (pagos) => {
        const total = this.roundMoney(
            (pagos || []).reduce((acc, p) => {
                return p.seleccionado ? acc + this.parseNumber(p?.facturable) : acc;
            }, 0)
        );

        const subtotal = this.roundMoney(total / 1.16);
        const iva = this.roundMoney(total - subtotal);

        this.setState((prev) => {
            const nextState = {
                ...prev,
                pagos,
                resumen: {
                    ...prev.resumen,
                    totalfactura: this.formatMoney(total),
                    ivafactura: this.formatMoney(iva),
                },
            };

            return {
                pagos,
                resumen: nextState.resumen,
                hasChanges: this.computeHasChanges(nextState),
            };
        });
    };

    onTogglePago = (rowid) => {
        this.setState(
            (prev) => {
                const pagos = prev.pagos.map((p) =>
                    p._rowid === rowid
                        ? { ...p, seleccionado: !p.seleccionado }
                        : p
                );

                return { pagos };
            },
            () => this.recalculateFromPagos(this.state.pagos)
        );
    };

    onSolicitudChange = (field, value) => {
        this.setState((prev) => {
            const solicitud = {
                ...prev.solicitud,
                [field]: value,
            };

            const nextState = {
                ...prev,
                solicitud,
            };

            return {
                solicitud,
                hasChanges: this.computeHasChanges(nextState),
            };
        });
    };

    onProductoChange = (index, field, value) => {
        this.setState((prev) => {
            const productos = [...prev.productos];

            productos[index] = {
                ...productos[index],
                [field]: value,
            };

            const nextState = {
                ...prev,
                productos,
            };

            return {
                productos,
                hasChanges: this.computeHasChanges(nextState),
            };
        });
    };

    getCatalogItems = (key) => {
        return this.props.catalogos?.[key] || [];
    };

    getCatalogLabel = (key, clave) => {
        const items = this.getCatalogItems(key);
        const target = String(clave || "").trim();
        if (!target) return "";

        const found = items.find((x) => String(x?.clave || "").trim() === target);
        if (!found) return "";

        switch (key) {
            case "forma_pago":
                return found.forma_pago || "";
            case "metodo_pago":
                return found.metodo_pago || "";
            case "regimen_fiscal":
                return found.regimen_fiscal || "";
            case "uso_cfdi":
                return found.uso_cfdi || "";
            case "tipo_comprobante":
                return found.tipo_comprobante || "";
            case "meses":
                return found.mes || "";
            case "periodicidades":
                return found.periodicidad || "";
            default:
                return "";
        }
    };

    validateBeforeSave = () => {
        const { solicitud, productos, pagos } = this.state;

        const pagosSeleccionados = pagos.filter((p) => p.seleccionado);
        if (pagosSeleccionados.length === 0) {
            toast.info("Debes seleccionar al menos un pago.");
            return false;
        }

        if (!String(solicitud.nombre || "").trim()) {
            toast.info("El nombre es obligatorio.");
            return false;
        }

        if (!String(solicitud.rfc || "").trim()) {
            toast.info("El RFC es obligatorio.");
            return false;
        }

        if (!String(solicitud.regimen_fiscal || "").trim()) {
            toast.info("Debes seleccionar el régimen fiscal.");
            return false;
        }

        if (!String(solicitud.domicilio_fiscal || "").trim()) {
            toast.info("El domicilio fiscal es obligatorio.");
            return false;
        }

        if (!String(solicitud.forma_pago || "").trim()) {
            toast.info("Debes seleccionar la forma de pago.");
            return false;
        }

        if (!String(solicitud.metodo_pago || "").trim()) {
            toast.info("Debes seleccionar el método de pago.");
            return false;
        }

        if (!String(solicitud.tipo_comprobante || "").trim()) {
            toast.info("Debes seleccionar el tipo de comprobante.");
            return false;
        }

        if (!String(solicitud.uso_cfdi || "").trim()) {
            toast.info("Debes seleccionar el uso CFDI.");
            return false;
        }

        if (!String(solicitud.periodicidad || "").trim()) {
            toast.info("Debes seleccionar la periodicidad.");
            return false;
        }

        if (!String(solicitud.meses || "").trim()) {
            toast.info("Debes seleccionar el mes.");
            return false;
        }

        if (!String(solicitud.anyo || "").trim()) {
            toast.info("El año es obligatorio.");
            return false;
        }

        if (!Array.isArray(productos) || productos.length === 0) {
            toast.info("Debe existir al menos un producto.");
            return false;
        }

        for (let i = 0; i < productos.length; i++) {
            const p = productos[i] || {};

            if (!String(p.clave_sat || "").trim()) {
                toast.info(`La clave SAT del producto ${i + 1} es obligatoria.`);
                return false;
            }

            if (!String(p.descripcion || p.producto || "").trim()) {
                toast.info(`La descripción del producto ${i + 1} es obligatoria.`);
                return false;
            }
        }

        return true;
    };

    getPayload = () => {
        const { solicitud, productos, pagos, resumen, afiliacion } = this.state;

        const pagosSeleccionados = (pagos || [])
            .filter((p) => !!p.seleccionado)
            .map((p) => ({
                idticketpago: Number(p.idticketpago || 0),
                facturable: this.roundMoney(this.parseNumber(p.facturable)),
            }))
            .filter((p) => p.idticketpago > 0);

        return {
            nombre: solicitud.nombre || "".replace(/\s+/g, " ").trim(),
            fecha_factura: solicitud.fecha_factura || "",
            rfc: solicitud.rfc || "",
            regimen_fiscal: solicitud.regimen_fiscal || "",
            domicilio_fiscal: solicitud.domicilio_fiscal || "",
            forma_pago: solicitud.forma_pago || "",
            metodo_pago: solicitud.metodo_pago || "",
            tipo_comprobante: solicitud.tipo_comprobante || "",
            uso_cfdi: solicitud.uso_cfdi || "",
            lugar_expedicion: solicitud.lugar_expedicion || "",
            periodicidad: solicitud.periodicidad || "",
            meses: solicitud.meses || "",
            anyo: solicitud.anyo || "",
            moneda: solicitud.moneda || resumen.monedafactura || "",
            cantidad: this.roundMoney(this.parseNumber(resumen.totalfactura)),
            folio: solicitud.folio || afiliacion.afiliacion || "",
            afiliacion: afiliacion.afiliacion || "",
            pagos: pagosSeleccionados,
            productos: (productos || []).map(p => ({
                producto: p.descripcion || "",
                cantidad: Number(p.cantidad || 1),
                clave_sat: p.clave_sat || "",
                total: this.roundMoney(this.parseNumber(resumen.totalfactura)),
            }))

        };
    };

    onSave = () => {
        if (!this.validateBeforeSave()) return;

        const payload = this.getPayload();

        if (this.props.onSave) {
            this.props.onSave(payload);
        }
    };

    canOpenFacturaExterna = () => {
        return !this.props.loading;
    };

    openFacturaExternaModal = () => {
        if (!this.canOpenFacturaExterna()) return;

        this.setState({
            showFacturaExternaModal: true,
            showFacturaExternaConfirm: false,
            uuidFacturaExterna: "",
        });
    };

    closeFacturaExternaModal = () => {
        this.setState({
            showFacturaExternaModal: false,
            showFacturaExternaConfirm: false,
            uuidFacturaExterna: "",
        });
    };

    onFacturaExternaUuidChange = (value) => {
        this.setState({ uuidFacturaExterna: value });
    };

    continuarFacturaExterna = () => {
        const uuid = String(this.state.uuidFacturaExterna || "").trim();

        if (!uuid) {
            toast.info("El UUID es obligatorio.");
            return;
        }

        if (this.hasSpecialChars(uuid)) {
            toast.info("El UUID contiene caracteres no permitidos.");
            return;
        }

        if (!this.validateBeforeSave()) return;

        this.setState({ showFacturaExternaConfirm: true });
    };

    closeFacturaExternaConfirm = () => {
        this.setState({ showFacturaExternaConfirm: false });
    };

    confirmarFacturaExterna = () => {
        const uuid = String(this.state.uuidFacturaExterna || "").trim();

        if (!uuid) {
            toast.info("El UUID es obligatorio.");
            return;
        }

        if (!this.validateBeforeSave()) return;

        const payload = {
            ...this.getPayload(),
            uuid,
        };

        this.setState(
            {
                showFacturaExternaModal: false,
                showFacturaExternaConfirm: false,
            },
            () => {
                if (this.props.onSaveExterna) {
                    this.props.onSaveExterna(payload);
                }
            }
        );
    };

    onSortPagos = (key) => {
        this.setState((prev) => {
            const sameKey = prev.pagosSortKey === key;
            const nextDir = sameKey && prev.pagosSortDir === "asc" ? "desc" : "asc";

            return {
                pagosSortKey: key,
                pagosSortDir: nextDir,
            };
        });
    };

    getPagoSortValue = (p, key) => {
        switch (key) {
            case "idticket":
            case "total":
            case "total_cobrado":
            case "propina":
            case "tc":
            case "facturable":
                return this.parseNumber(p?.[key]);

            case "locacion":
            case "moneda_cobro":
                return String(p?.[key] || "").toLowerCase();

            default:
                return String(p?.[key] || "").toLowerCase();
        }
    };

    getSortedPagos = () => {
        const { pagos, pagosSortKey, pagosSortDir } = this.state;

        if (!pagosSortKey) return pagos || [];

        return [...(pagos || [])].sort((a, b) => {
            const va = this.getPagoSortValue(a, pagosSortKey);
            const vb = this.getPagoSortValue(b, pagosSortKey);

            let result = 0;

            if (typeof va === "number" && typeof vb === "number") {
                result = va - vb;
            } else {
                result = String(va).localeCompare(String(vb), "es", {
                    numeric: true,
                    sensitivity: "base",
                });
            }

            return pagosSortDir === "asc" ? result : result * -1;
        });
    };



    renderReadField = (label, value, extraClass = "", valueClass = "") => (
        <div className={`vd-field ${extraClass}`}>
            <label>{label}</label>
            <div className={`vd-value ${valueClass}`}>{value || ""}</div>
        </div>
    );

    renderEditField = (
        label,
        value,
        onChange,
        type = "text",
        extraClass = "",
        placeholder = ""
    ) => (
        <div className={`vd-field ${extraClass}`}>
            <label>{label}</label>
            <input
                type={type}
                value={value || ""}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    );

    renderSelectField = ({
        label,
        value,
        onChange,
        options = [],
        extraClass = "",
        placeholder = "Selecciona",
    }) => (
        <div className={`vd-field ${extraClass}`}>
            <label>{label}</label>
            <select value={value || ""} onChange={(e) => onChange(e.target.value)}>
                <option value="">{placeholder}</option>
                {options.map((opt, idx) => (
                    <option
                        key={`${opt?.value || opt?.clave}-${idx}`}
                        value={opt?.value || opt?.clave || ""}
                    >
                        {opt?.label || opt?.text || ""}
                    </option>
                ))}
            </select>
        </div>
    );

    renderFacturaExternaModal = () => {
        if (!this.state.showFacturaExternaModal) return null;

        return (
            <div className="vd-confirmBackdrop">
                <div className="vd-confirmModal vd-externalModal">
                    <div className="vd-confirmTitle">Generar factura externa</div>

                    <div className="vd-confirmBody vd-externalBody">
                        <div className="vd-field vd-externalField">
                            <label>UUID</label>
                            <input
                                type="text"
                                value={this.state.uuidFacturaExterna}
                                placeholder="UUID de la factura externa"
                                autoFocus
                                onChange={(e) =>
                                    this.onFacturaExternaUuidChange(e.target.value)
                                }
                            />
                        </div>
                    </div>

                    <div className="vd-confirmActions">
                        <button
                            type="button"
                            className="vd-btn vd-btnGhost"
                            onClick={this.closeFacturaExternaModal}
                        >
                            Cancelar
                        </button>

                        <button
                            type="button"
                            className="vd-btn vd-btnPrimary"
                            onClick={this.continuarFacturaExterna}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    renderFacturaExternaConfirm = () => {
        if (!this.state.showFacturaExternaConfirm) return null;

        const uuid = String(this.state.uuidFacturaExterna || "").trim();

        return (
            <div className="vd-confirmBackdrop vd-confirmBackdropTop">
                <div className="vd-confirmModal">
                    <div className="vd-confirmTitle">Generar factura externa</div>

                    <div className="vd-confirmBody">
                        Se generará una factura pública externa con el UUID:
                        <br />
                        <b>{uuid || "—"}</b>
                        <br />
                        ¿Desea continuar?
                    </div>

                    <div className="vd-confirmActions">
                        <button
                            type="button"
                            className="vd-btn vd-btnGhost"
                            onClick={this.closeFacturaExternaConfirm}
                        >
                            Cancelar
                        </button>

                        <button
                            type="button"
                            className="vd-btn vd-btnPrimary"
                            onClick={this.confirmarFacturaExterna}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    renderResumen = () => {
        const { afiliacion, solicitud, resumen } = this.state;

        return (
            <div className="vd-summaryBar">
                <div className="vd-summaryMain">
                    <div className="vd-summaryTitle">
                        Afiliación #{afiliacion.afiliacion || "—"}
                    </div>
                </div>

                <div className="vd-summaryStats">
                    <div className="vd-stat">
                        <span className="vd-statLabel">Moneda factura</span>
                        <span className="vd-statValue">
                            {resumen.monedafactura || solicitud.moneda || "—"}
                        </span>
                    </div>

                    <div className="vd-stat vd-statEditable">
                        <span className="vd-statLabel">Fecha factura</span>
                        <input
                            className="vd-statInput"
                            type="date"
                            value={String(solicitud.fecha_factura || "").slice(0, 10)}
                            onChange={(e) =>
                                this.onSolicitudChange("fecha_factura", e.target.value)
                            }
                        />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { show, loading, onClose } = this.props;
        const { afiliacion, solicitud, emisor, pagos, productos, resumen } = this.state;

        if (!show) return null;


        const formaPagoOptions = this.getCatalogItems("forma_pago").map((x) => ({
            value: x.clave,
            label: `${x.clave} ${x.forma_pago}`,
        }));

        const metodoPagoOptions = this.getCatalogItems("metodo_pago").map((x) => ({
            value: x.clave,
            label: `${x.clave} ${x.metodo_pago}`,
        }));

        const regimenFiscalOptions = this.getCatalogItems("regimen_fiscal").map(
            (x) => ({
                value: x.clave,
                label: `${x.clave} ${x.regimen_fiscal}`,
            })
        );

        const usoCfdiOptions = this.getCatalogItems("uso_cfdi").map((x) => ({
            value: x.clave,
            label: `${x.clave} ${x.uso_cfdi}`,
        }));

        const tipoComprobanteOptions = this.getCatalogItems(
            "tipo_comprobante"
        ).map((x) => ({
            value: x.clave,
            label: `${x.clave} ${x.tipo_comprobante}`,
        }));

        const periodicidadOptions = this.getCatalogItems("periodicidades").map(
            (x) => ({
                value: x.clave,
                label: `${x.clave} ${x.periodicidad}`,
            })
        );

        const mesesOptions = this.getCatalogItems("meses").map((x) => ({
            value: x.clave,
            label: `${x.clave} ${x.mes}`,
        }));

        const sumaPagos = pagos.reduce((acc, p) => {
            return p.seleccionado ? acc + this.parseNumber(p.facturable) : acc;
        }, 0);

        const pagosOrdenados = this.getSortedPagos();

        return (
            <div className="vd-backdrop vd-backdropTop">
                <div className="vd-modal vd-modalWide vd-modalTop vd-modalPublica">
                    <div className="vd-head">
                        <div className="vd-headText">
                            <div className="vd-title">Detalle de factura pública</div>
                        </div>

                        <div className="vd-headActions">
                            {this.canOpenFacturaExterna() && (
                                <button
                                    type="button"
                                    className="vd-iconBtn"
                                    title="Generar factura externa"
                                    aria-label="Generar factura externa"
                                    onClick={this.openFacturaExternaModal}
                                >
                                    ⚙
                                </button>
                            )}

                            <button type="button" className="vd-close" onClick={onClose}>
                                ×
                            </button>
                        </div>
                    </div>

                    {loading ? (
                        <div className="vd-loading">Cargando detalles...</div>
                    ) : (
                        <>
                            {this.renderResumen()}

                            <div className="vd-body vd-bodyNoHorizontal">
                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">Afiliación</div>
                                            <div className="vd-cardDesc">
                                                Información principal de la afiliación.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridSolicitud">
                                        {this.renderReadField("Afiliación", afiliacion.afiliacion)}
                                        {this.renderReadField("Moneda", afiliacion.moneda)}
                                        {this.renderReadField("Banco", afiliacion.banco)}

                                        {this.renderReadField("Compañía", afiliacion.compania)}
                                        {this.renderReadField("Cuenta", afiliacion.cuenta)}

                                        {this.renderReadField(
                                            "Comentarios",
                                            afiliacion.comentarios,
                                            "vd-span-3"
                                        )}
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">
                                                Información de factura
                                            </div>
                                            <div className="vd-cardDesc">
                                                Datos generales para la factura pública.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridSolicitud">
                                        {this.renderEditField(
                                            "Nombre",
                                            solicitud.nombre,
                                            (v) => this.onSolicitudChange("nombre", v)
                                        )}


                                        {this.renderReadField("Apellido", afiliacion.apellido)}



                                        {this.renderEditField(
                                            "RFC",
                                            solicitud.rfc,
                                            (v) => this.onSolicitudChange("rfc", v)
                                        )}

                                        {this.renderSelectField({
                                            label: "Régimen Fiscal *",
                                            value: solicitud.regimen_fiscal,
                                            onChange: (v) =>
                                                this.onSolicitudChange("regimen_fiscal", v),
                                            options: regimenFiscalOptions,
                                        })}

                                        {this.renderEditField(
                                            "Domicilio Fiscal",
                                            solicitud.domicilio_fiscal,
                                            (v) => this.onSolicitudChange("domicilio_fiscal", v)
                                        )}


                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">Emisor</div>
                                            <div className="vd-cardDesc">
                                                Información no editable.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridTwoCols">
                                        {this.renderReadField("Nombre", emisor.nombre)}
                                        {this.renderReadField("RFC", emisor.rfc)}

                                        {this.renderEditField(
                                            "Lugar Expedición",
                                            solicitud.lugar_expedicion,
                                            (v) => this.onSolicitudChange("lugar_expedicion", v)
                                        )}

                                        {this.renderReadField(
                                            "Régimen Fiscal",
                                            `${emisor.regimen_fiscal || ""} ${this.getCatalogLabel(
                                                "regimen_fiscal",
                                                emisor.regimen_fiscal
                                            )}`.trim()
                                        )}
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">CFDI 4.0</div>
                                            <div className="vd-cardDesc">
                                                Datos fiscales de la factura.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridSolicitud">
                                        {this.renderEditField(
                                            "Serie",
                                            solicitud.serie,
                                            (v) => this.onSolicitudChange("serie", v)
                                        )}

                                        {this.renderEditField(
                                            "Folio",
                                            solicitud.folio,
                                            (v) => this.onSolicitudChange("folio", v)
                                        )}

                                        {this.renderReadField(
                                            "Tipo Cambio",
                                            resumen.tipocambiofactura
                                        )}

                                        {this.renderSelectField({
                                            label: "Forma Pago *",
                                            value: solicitud.forma_pago,
                                            onChange: (v) =>
                                                this.onSolicitudChange("forma_pago", v),
                                            options: formaPagoOptions,
                                        })}

                                        {this.renderSelectField({
                                            label: "Método Pago *",
                                            value: solicitud.metodo_pago,
                                            onChange: (v) =>
                                                this.onSolicitudChange("metodo_pago", v),
                                            options: metodoPagoOptions,
                                        })}

                                        {this.renderSelectField({
                                            label: "Tipo Comprobante *",
                                            value: solicitud.tipo_comprobante,
                                            onChange: (v) =>
                                                this.onSolicitudChange("tipo_comprobante", v),
                                            options: tipoComprobanteOptions,
                                        })}

                                        {this.renderSelectField({
                                            label: "Uso CFDI *",
                                            value: solicitud.uso_cfdi,
                                            onChange: (v) =>
                                                this.onSolicitudChange("uso_cfdi", v),
                                            options: usoCfdiOptions,
                                        })}

                                        {this.renderReadField("Moneda *", solicitud.moneda)}

                                        {this.renderReadField("Cantidad *", this.formatCurrency(sumaPagos))}

                                        {this.renderSelectField({
                                            label: "Periodicidad *",
                                            value: solicitud.periodicidad,
                                            onChange: (v) =>
                                                this.onSolicitudChange("periodicidad", v),
                                            options: periodicidadOptions,
                                        })}

                                        {this.renderSelectField({
                                            label: "Mes *",
                                            value: solicitud.meses,
                                            onChange: (v) => this.onSolicitudChange("meses", v),
                                            options: mesesOptions,
                                        })}

                                        {this.renderEditField(
                                            "Año *",
                                            solicitud.anyo,
                                            (v) => this.onSolicitudChange("anyo", v)
                                        )}
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead vd-cardHeadProducts">
                                        <div>
                                            <div className="vd-cardTitle">Pagos</div>
                                            <div className="vd-cardDesc">
                                                Selecciona los pagos que sí entrarán en la factura.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-tableWrap">
                                        <table className="vd-table">
                                            <thead>
                                                <tr>
                                                    <th className="vd-thCheck">
                                                        <input
                                                            type="checkbox"
                                                            checked={this.areAllPagosSelected()}
                                                            onChange={this.onToggleAllPagos}
                                                        />
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("idticket")}>
                                                        Ticket
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("locacion")}>
                                                        Locación
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("metodo_pago")}>
                                                        Metodo de pago
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("total")}>
                                                        Total
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("moneda_cobro")}>
                                                        Moneda
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("total_cobrado")}>
                                                        Total Cobrado
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("propina")}>
                                                        Propina
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("tc")}>
                                                        T. C.
                                                    </th>

                                                    <th className="vd-sortableTh" onClick={() => this.onSortPagos("facturable")}>
                                                        Facturable
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pagosOrdenados.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="9" className="vd-empty">
                                                            No hay pagos disponibles
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    pagosOrdenados.map((p) => (
                                                        <tr
                                                            key={p._rowid}
                                                            className={p.seleccionado ? "vd-rowSelected" : ""}
                                                        >
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={!!p.seleccionado}
                                                                    onChange={() => this.onTogglePago(p._rowid)}
                                                                />
                                                            </td>

                                                            <td>{p.idticket || "—"}</td>
                                                            <td>{p.locacion || "—"}</td>
                                                            <td>{p.metodo_pago || "—"}</td>
                                                            <td>{this.formatCurrency(p.total)}</td>
                                                            <td>{p.moneda_cobro || "—"}</td>

                                                            <td
                                                                style={{
                                                                    fontWeight: p.diferencia === 1 ? "bold" : "normal",
                                                                    color: p.diferencia === 1 ? "red" : "black",
                                                                }}
                                                            >
                                                                {this.formatCurrency(p.total_cobrado) || "—"}
                                                            </td>

                                                            <td>{this.formatCurrency(p.propina)}</td>
                                                            <td>{p.tc || "—"}</td>
                                                            <td>{this.formatCurrency(p.facturable)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="vd-tableFooterTotal">
                                        <span className="vd-tableFooterLabel">Total:</span>
                                        <span className="vd-tableFooterValue">
                                            {this.formatCurrency(sumaPagos)}
                                        </span>
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead vd-cardHeadProducts">
                                        <div>
                                            <div className="vd-cardTitle">Producto</div>
                                            <div className="vd-cardDesc">
                                                Solo se puede editar la clave SAT y el nombre del
                                                producto.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-tableWrap">
                                        <table className="vd-table">
                                            <thead>
                                                <tr>
                                                    <th>Producto</th>
                                                    <th>Cantidad</th>
                                                    <th>Clave SAT</th>
                                                    <th>IVA 16%</th>
                                                    <th>Subtotal</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productos.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="vd-empty">
                                                            No hay productos disponibles
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    productos.map((p, idx) => (
                                                        <tr key={p._rowid || idx}>
                                                            <td>
                                                                <input
                                                                    className="vdfftableInput"
                                                                    type="text"
                                                                    value={p.descripcion || ""}
                                                                    onChange={(e) =>
                                                                        this.onProductoChange(idx, "descripcion", e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            <td>{p.cantidad || 1}</td>

                                                            <td>
                                                                <input
                                                                    className="vdfftableInputsat"
                                                                    type="text"
                                                                    value={p.clave_sat || ""}
                                                                    onChange={(e) =>
                                                                        this.onProductoChange(idx, "clave_sat", e.target.value)
                                                                    }
                                                                />
                                                            </td>

                                                            <td>{this.formatCurrency(p.iva || 0)}</td>
                                                            <td>{this.formatCurrency(p.subtotal || 0)}</td>
                                                            <td>{this.formatCurrency(resumen.totalfactura || 0)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-grid vd-gridFacturacionFinal">

                                        {this.renderReadField("T. C. Factura", resumen.tipocambiofactura)}

                                        {this.renderReadField("Moneda Factura", resumen.monedafactura)}

                                        {this.renderReadField("IVA Factura", this.formatCurrency(resumen.ivafactura))}
                                        {this.renderReadField("Total Factura", this.formatCurrency(resumen.totalfactura))}


                                    </div>
                                </div>
                            </div>

                            <div className="vd-foot vd-footSplit">
                                <div className="vd-footLeft"></div>

                                <div className="vd-footRight">
                                    <button
                                        type="button"
                                        className="vd-btn vd-btnGhost"
                                        onClick={onClose}
                                    >
                                        Cerrar
                                    </button>

                                    <button
                                        type="button"
                                        className="vd-btn vd-btnPrimary"
                                        onClick={this.onSave}
                                    >
                                        Facturar
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    {this.renderFacturaExternaModal()}
                    {this.renderFacturaExternaConfirm()}
                </div>
            </div>
        );
    }
}
